<template>
  <v-flex
    column
    role="region"
    aria-label="Landing page content"
  >
    <zushin-cover />
    <v-card flat>
      <v-layout
        :class="{
          column: $vuetify.breakpoint.mdAndDown,
          row: $vuetify.breakpoint.lgAndUp
        }"
        wrap
        role="region"
        aria-label="Zushin updates section"
      >
        <v-flex
          xs12
          sm12
          md12
          lg6
          justify-center
        >
          <carsousel
            :items="notes"
            :has-effect="true"
            aria-label="Notes carousel"
            role="region"
          />
        </v-flex>

        <v-flex
          xs12
          sm12
          md12
          lg6
          justify-center
        >
          <carsousel
            :items="events"
            :has-effect="true"
            aria-label="Events carousel"
            role="region"
          />
        </v-flex>

        <v-flex
          xs12
          sm12
          md12
          lg12
          justify-center
        >
          <carsousel
            :items="guides"
            :has-effect="false"
            aria-label="Guides carousel"
            role="region"
          />
        </v-flex>

        <v-flex
          v-if="notes.length === 0"
          xs12
          sm12
          md12
          lg6
          justify-center
        >
          <v-card>
            <v-card-actions>
              <v-flex class="align-middle justify-middle text-center column height">
                <v-btn
                  large
                  icon
                  aria-label="Loading notes"
                  role="status"
                >
                  <v-icon>fal fa-circle-notch fa-spin</v-icon>
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          sm12
          md12
          lg6
          justify-center
        >
          <v-card v-if="events.length === 0">
            <v-card-actions>
              <v-flex class="align-middle justify-middle text-center column height">
                <v-btn
                  large
                  icon
                  aria-label="Loading events"
                  role="status"
                >
                  <v-icon>fal fa-circle-notch fa-spin</v-icon>
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          sm12
          md12
          lg12
          justify-center
        >
          <v-card v-if="guides.length === 0">
            <v-card-actions>
              <v-flex class="align-middle justify-middle text-center column height">
                <v-btn
                  large
                  icon
                  aria-label="Loading guides"
                  role="status"
                >
                  <v-icon>fal fa-circle-notch fa-spin</v-icon>
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>

    <posts
      :posts="posts"
      :is-loading="isListsLoading"
      role="region"
      aria-label="Latest Zushin posts"
    />

    <v-parallax
      dark
      src="https://gm.goz.fun/wp-content/uploads/2023/03/review-cover.png"
      class="pt-10"
      aria-label="Reviews and Ads section"
      role="region"
    >
      <v-layout
        class="row"
        wrap
      >
        <v-flex
          xs12
          sm12
          md12
          lg6
          justify-center
        >
          <review-card />
        </v-flex>
        <v-flex
          xs12
          sm12
          md12
          lg6
          justify-center
        >
          <ad-carousel />
        </v-flex>
      </v-layout>
    </v-parallax>

    <v-parallax
      v-if="canHideRegistrationForm"
      dark
      src="https://gm.goz.fun/wp-content/uploads/2023/03/rapid-register-cover.png"
      class="pt-10"
      aria-label="Rapid registration section"
      role="region"
    >
      <v-layout
        class="row"
        wrap
      >
        <v-flex
          xs12
          sm12
          md12
          lg12
          justify-center
        >
          <rapid-register-form
            @onFinishedRegistration="onFinishedRegistration"
            @onStartedRegistration="onStartedRegistration"
          />
        </v-flex>
      </v-layout>
    </v-parallax>

    <!-- <PhysicalShopCollection
      :title="$t('components.goodsShop.title')"
      :description="$t('components.goodsShop.description')"
      :collection="products"
      :is-loading="products.length === 0"
    /> -->
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
import links from '@/constants/links';
import { toPaginatedPosts, toPosts } from "@/utils/post.utils";

export default {
    name: "Landing",
    components: {
        Carsousel: () => import("@/components/Views/Carousel.vue"),
        ZushinCover: () => import("@/components/Views/ZushinCover.vue"),
        Posts: () => import("@/components/Views/Posts.vue"),
        AdCarousel: () => import("@/components/Views/AdCarousel.vue"),
        ReviewCard: () => import("@/components/Views/ReviewCard.vue"),
        RapidRegisterForm: () => import("@/components/Views/RapidRegisterForm.vue"),
        // PhysicalShopCollection: () => import("@/components/Views/PhysicalShopCollection.vue")
    },
    data() {
        return {
            notes: [],
            events: [],
            posts: [],
            guides: [],
            // products: [],
            limit: 5,
            rapidRegistrationFormStatus: false,
            rapidRegistrationInProgress: false,
        }
    },
    computed: {
        ...mapGetters(['isLogged']),

        cover: () => links.assets.cover,

        canHideRegistrationForm() {
            return !(this.rapidRegistrationFormStatus || !this.rapidRegistrationInProgress && this.isLogged)
        },
        isListsLoading() {
            return this.notes.length === 0 ||
            this.posts.length === 0 ||
            this.guides.length === 0 ||
            this.events.length === 0 //||
            //this.products.length === 0
        }
    },
    async beforeMount() {
        this.events = toPosts(await this.$api.getEvents(this.limit), this.$route.query.slug);
        this.notes = toPosts(await this.$api.getNotes(this.limit), this.$route.query.slug);
        this.guides = toPosts(await this.$api.getGuides(this.limit), this.$route.query.slug);
        // this.products = await this.$api.getGoodsShopProducts();

        this.posts = toPaginatedPosts(await this.$api.getPosts(), this.$route.query.slug);
    },
    methods: {
        onFinishedRegistration(value) {
            this.rapidRegistrationFormStatus = value;
        },
        onStartedRegistration(value) {
            this.rapidRegistrationInProgress = value;
        }
    }
};
</script>

<style lang="scss">
@import '~/_variables.scss';

    .landing {
        &-cover {
            .v-parallax__content {
                padding: 0 !important;
            }

            &-layout {
                background-image: $zushin-cover;
            }

            &-title {
                min-height: 4rem;
                font-family: 'Manga Speak Two';
                font-size: 3.5rem;
                font-weight: bolder;
                color: $white;
                text-align: center;
                padding: 0.5rem;
            }

            &-subtitle {
                font-family: 'Manga Temple';
                font-size: 1.2rem;
                color: $white;
                text-align: center;
                padding: 0.5rem;
            }

            &-freetoplay-icon {
                font-family: "Manga Temple";
                font-size: 1.6rem;
                color: $white;
                text-align: left;
                padding: 0.5rem;
                width: 21rem;
                height: 5rem;
                padding-top: 0.6rem;
                padding-left: 3.2rem;
                background-size: cover;
                background-image: url($download-btn);
                background-position-x: 1vw;
                background-position-y: -0.4vw;

                &:focus {
                    outline: 2px solid #96b3eb;
                    outline-offset: 2px;
                }
            }
        }

        .is-small .landing-cover-title {
            font-size: 2.5rem;
        }

        &-carsoul-item {

            &:hover {
                &:after {
                    height: 98rem;
                    width: 100rem;
                    left: -82rem;
                }
            }

            &:after {
                content: "";
                height: 50rem;
                width: 30rem;
                left: -86rem;
                top: -4rem;
                opacity: 0.2;
                position: absolute;
                z-index: 2;
                background-color: $white;
                transform: rotate(35deg);
                transition: all 850ms cubic-bezier(0.19, 1, 0.22, 1);
            }
        }

        &-carsoul-content {
            padding: 1rem;
            height: 14rem;
            background-image: $slider;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            position: relative;
            overflow: hidden;

            &-title {
                font-size: 1rem;
                font-family: "Manga Speak Two";
                padding: 1rem 1rem 0.5rem 2rem;
                text-align: left;
                margin: 0 0 0rem 0;
                color: whitesmoke;
                width: 100%;
                border-bottom: 1px solid $primary;
            }

            &-date {
                font-size: 0.9rem;
                text-indent: 2px;
                font-family: 'Manga Speak Two';
                padding: .2rem .2rem .2rem 2.5rem;
                text-align: left;
                color: $gallery;
                width: 100%;
                margin-top: 0.5rem;
                text-align: left;
            }

            &-btns {
                width: 100%;
                justify-content: flex-end;
            }

            &-btn {
                color: $white !important;
                text-shadow: 0 1px 0 $primary;
                text-align: center;

                &:hover {
                    &:after {
                        height: 98rem;
                        width: 100rem;
                        left: -82rem;
                    }
                }

                &:after {
                    content: "";
                    height: 50rem;
                    width: 30rem;
                    left: -86rem;
                    top: -4rem;
                    opacity: 0.2;
                    position: absolute;
                    z-index: 2;
                    background-color: $white;
                    transform: rotate(35deg);
                    transition: all 850ms cubic-bezier(0.19, 1, 0.22, 1);
                }
            }
        }

        &-post {
            min-height: 290px;

            &-title {
                min-height: 142px;
                align-items: unset;
            }
        }

        &-posts-container {
            background: $primary;
        }

        &-news-title {
            font-family: "Manga Temple";
            text-align: left;
        }
    }
</style>
